import React from 'react';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import PropTypes from 'prop-types';
import { Text, SimpleFlexbox, getSimpleLabel } from 'ctm-components';
import styles from './car_excess_amount.css';

/**
 * CarExcessAmount shows the excess amount of a Product result
 * @return {Node} CarExcessAmount car Excess Amount component
 */
const _CarExcessAmount = ({ contentProps, stateProps, tagName, dataId, size, color, excessFilterValue, isChoosi }) => (
    <>
        { (stateProps.product.getIn(['productMeta', 'excess']) <= excessFilterValue || isChoosi)
        && (
            <SimpleFlexbox display="flex" itemCenter="xs" contentCenter="xs" className={styles.excess}>
                <Text dataId={dataId} stateProps={stateProps} {...contentProps} tagName={tagName} size={size} color={color} />
                <span className={styles.label}>
                    {getSimpleLabel(contentProps)}
                </span>
            </SimpleFlexbox>
        )}

        { (stateProps.product.getIn(['productMeta', 'excess']) > excessFilterValue && !isChoosi)
        && (
            <>
                <SimpleFlexbox display="flex" itemCenter="xs" contentCenter="xs">
                    <Text dataId={dataId} stateProps={stateProps} {...contentProps} tagName={tagName} size={size} color={color} className={styles.redLabel} />
                    <span className={styles.redLabelTxt}>
                        {getSimpleLabel(contentProps)}
                    </span>
                </SimpleFlexbox>
                <SimpleFlexbox display="flex" itemCenter="xs" contentCenter="xs">
                    <div className={styles.highExcess}>
                        Excess is higher than the&nbsp;
                        <strong>
                            $
                            {excessFilterValue}
                        </strong>
                        &nbsp;currently set
                    </div>
                </SimpleFlexbox>
            </>
        )}
    </>
);

_CarExcessAmount.propTypes = {
    contentProps: PropTypes.object,
    tagName: PropTypes.string,
    dataId: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    stateProps: PropTypes.object,
    excessFilterValue: PropTypes.string,
    isChoosi: PropTypes.bool
};

const mapStateToProps = (state) => {
    const form = quoteFormSelector(state);
    const excessFilterValue = form.getIn(['coverDetail', 'requestedExcess']);
    const brandCode = process.env.EVEREST_THEME?.trim();
    const isChoosi = brandCode === 'choo';
    return {
        excessFilterValue,
        isChoosi
    };
};

const CarExcessAmount = connect(mapStateToProps)(_CarExcessAmount);
export { _CarExcessAmount, CarExcessAmount };
